import React, { Fragment } from 'react';
import classNames from 'classnames';
import { Button } from 'components';
import Icon from 'assets/icons';
import styles from './SelectButton.module.scss';

const button = (
  <Fragment>
    <Icon.PlusCircle className={styles.icon} />
  </Fragment>
);

interface SelectButtonProps {
  noBorder?: boolean;
  className: any;
  onOpenModal?: any;
  size: any;
}

export const SelectButton: React.FC<SelectButtonProps> = ({ className, noBorder, onOpenModal, size }) => (
  <Button
    className={classNames(className, styles.button, {
      [styles[`size-${size}`]]: size,
      [styles.noBorder]: noBorder,
    })}
    type="Plain"
    onClick={() => onOpenModal()}
  >
    {button}
  </Button>
);
